<template>
  <BaseRoundButton
    icon="rotate-cw"
    :size="size"
    is-white
    is-floating
    :disabled="disabled"
    :is-loading="refreshing"
    :aria-label="label"
    :tooltip-text="hasTooltip ? label : ''"
    @click.native="onClick"
  />
</template>

<script>
import BaseRoundButton from '@/components/base/BaseRoundButton.vue';
import { viewport } from '@/util/viewport';

// A list's refresh button (docs/page-layout.md). It turns from the press until the refresh it
// started is done; the page's other loads (opening it, a filter, an action) are the list's to
// show, not this button's.
export default {
  name: 'BaseRefreshButton',
  components: { BaseRoundButton },
  props: {
    // The list is loading.
    pending: { type: Boolean, default: false },
    size: { type: Number, default: 36 },
    disabled: { type: Boolean, default: false },
    tooltip: { type: String, default: '' },
  },
  data() {
    return { refreshing: false };
  },
  computed: {
    label() {
      return this.tooltip || this.$t('actions.refresh');
    },
    hasTooltip() {
      return viewport.canHover;
    },
  },
  watch: {
    pending(isPending) {
      if (!isPending) this.refreshing = false;
    },
  },
  methods: {
    onClick() {
      this.refreshing = true;
      this.$emit('refresh');
      // A refresh that didn't start loading (nothing to fetch) is done already.
      this.$nextTick(() => {
        if (!this.pending) this.refreshing = false;
      });
    },
  },
};
</script>
